<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" :rules="rules" label-width="auto" ref="form" size="small">
      <div style="margin-bottom: 15px">已勾选 <span class="color-primary">{{dialogData.list.length}}</span> 台设备，为其自定义信息</div>
      <el-form-item label="设备名" prop="name">
        <el-input v-model.trim="form.name" clearable/>
      </el-form-item>
      <el-form-item label="自定义名称" prop="name_x">
        <el-input v-model.trim="form.name_x" clearable/>
      </el-form-item>
      <el-form-item label="设备型号" prop="model">
        <el-input v-model.trim="form.model" clearable/>
      </el-form-item>
      <el-form-item label="自定义型号" prop="model_x">
        <el-input v-model.trim="form.model_x" clearable/>
      </el-form-item>
      <el-form-item label="硬件平台" prop="plat">
        <el-select v-model="form.plat" filterable>
          <el-option v-for="(item, index) in platformType" :key="index" :label="item" :value="item"/>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" type="textarea" :rows="3" clearable resize="none" :maxlength="128" placeholder="请填写申请人、申请说明"/>
      </el-form-item>
    </el-form>
    <custom-result v-if="customResult.visible" :dialog-data="customResult" @finish="finish"/>
  </vue-dialog>
</template>

<script>
  import {openLoading, closeLoading} from "@utils/element"
  import CustomResult from "./CustomResult"
  import axios from "axios"
  import {changeEmpty, checkNameModel, inputEmpty} from "@utils/validate"
  import {platformType} from "@utils/formatList"
  import {dealParams} from "@/axios";
  export default {
    name: "CustomDeviceBatch",
    components: {CustomResult},
    props: {dialogData: Object},
    data() {
      return {
        platformType,
        form: {
          name: "",
          name_x: "",
          model: "",
          model_x: "",
          plat: "",
          remark: "",
        },
        rules: {
          name: [inputEmpty("设备名"), checkNameModel()],
          name_x: [inputEmpty("自定义名称"), checkNameModel()],
          model: [inputEmpty("设备型号"), checkNameModel()],
          model_x: [inputEmpty("自定义型号"), checkNameModel()],
          plat: [changeEmpty("硬件平台")],
          remark: [inputEmpty("备注")]
        },
        customResult: {visible: false, title: "执行结果", hideBtn: true, width: 600, list: [], result: {}, hideClose: true, name_x: "", model_x: ""}
      }
    },
    methods: {
      finish() {
        this.dialogData.visible = false;
        this.$emit("table-reload");
      },
      confirm() {
        this.$refs["form"].validate(async isOk => {
          if (isOk) {
            this.openConfirm("自定义信息", async () => {
              const loading = openLoading({background: "rgba(255,255,255,0.9)"});
              const result = {ok: 0, fail: 0};
              const list = [];
              const {uid, token} = this.$store.state;
              const doAction = async item => {
                let nv = {...this.form, device_custom_id: item.id};
                nv = dealParams(nv)
                try {
                  let {data} = await axios.post("adm/v3/device-custom/mod", nv, {
                    baseURL: process.env.VUE_APP_BASE_API,
                    timeout: 30000,
                    headers: {
                      "Authorization": token,
                      "X-Wys-Uid": uid,
                    }});
                  +data.code === 0 ? result.ok++ : result.fail++;
                  list.push({...item, result: data});
                } catch (e) {
                  result.fail++;
                  list.push({...item, result: {code: -1, msg: "接口请求失败！"}});
                }
              }
              for (let item of this.dialogData.list) {
                loading.setText(`自定义中... ${list.length + 1} / ${this.dialogData.list.length}`);
                await doAction(item);
              }
              closeLoading();
              this.customResult.visible = true;
              this.customResult.result = result;
              this.customResult.list = list;
              this.customResult.name_x = this.form.name_x;
              this.customResult.model_x = this.form.model_x;
            });
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
